"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GRAPHQL_WS = 'graphql-ws';
exports.GRAPHQL_WS = GRAPHQL_WS;
var GRAPHQL_SUBSCRIPTIONS = 'graphql-subscriptions';
exports.GRAPHQL_SUBSCRIPTIONS = GRAPHQL_SUBSCRIPTIONS;
//# sourceMappingURL=protocol.js.map


//////////////////
// WEBPACK FOOTER
// ./~/subscriptions-transport-ws/dist/protocol.js
// module id = ./node_modules/subscriptions-transport-ws/dist/protocol.js
// module chunks = 0